import React from 'react'
import { translatable } from 'react-instantsearch-core'
import { createClassNames } from '../../../helpers'
import InputCheckbox from '@bit/atd.web.forms.input-checkbox'
import List from '../List'
import FilterResults from '../FilterResults'

const cx = createClassNames('RefinementList')

type PropItem = {
  label: string
  value: boolean
  count: boolean
  isRefined: boolean
}

type PropsType = {
  translate: (key: string, ...params: any[]) => string
  refine: (item: any) => void
  searchForItems: () => void
  searchable: boolean
  createURL: () => void
  items: PropItem[]
  isFromSearch: boolean
  canRefine: boolean
  showMore: boolean
  limit: number
  showMoreLimit: number
  transformItems?: () => void
  className?: string
}

const RefinementList = (props: PropsType) => {
  const {
    translate,
    items,
    showMore,
    limit,
    showMoreLimit,
    isFromSearch,
    searchForItems,
    searchable,
    canRefine,
    className,
  } = props

  const state = {
    query: '',
  }

  const selectItem = (item: PropItem, resetQuery: () => void) => {
    resetQuery()
    props.refine(item.isRefined ? [] : item.value)
  }

  const renderItem = (item: PropItem, resetQuery: any) => {
    return (
      <label className={cx('label')}>
        <InputCheckbox
          name={item.label}
          label={item.label}
          labelPlacement="right"
          size="small"
          checked={item.isRefined}
          onChange={() => selectItem(item, resetQuery)}
        />
      </label>
    )
  }

  return (
    <FilterResults>
      {items.length ? (
        <List
          renderItem={renderItem}
          selectItem={selectItem}
          cx={cx}
          translate={translate}
          items={items}
          showMore={showMore}
          limit={limit}
          showMoreLimit={showMoreLimit}
          isFromSearch={isFromSearch}
          searchForItems={searchForItems}
          searchable={searchable}
          canRefine={canRefine}
          className={className}
          //  @ts-ignore
          query={state.query}
        />
      ) : (
        <div>no options available</div>
      )}
    </FilterResults>
  )
}

RefinementList.defaultProps = {
  className: '',
}

export default translatable({
  showMore: (extended) => (extended ? 'Show less' : 'Show more'),
  noResults: 'No results',
  //  @ts-ignore
  submit: null,
  //  @ts-ignore
  reset: null,
  resetTitle: 'Clear the search query.',
  submitTitle: 'Submit your search query.',
  placeholder: 'Search here…',
})(RefinementList)
